import { useMemo } from 'react';
import { useExtendedWorkforceEntities } from './use-extended-workforce-entities';
import { useReportPlaces } from 'extensions/widget/hooks/use-poi-hooks';

/**
 * Check if all entities in the report are extended workforce entities
 */
export const useAllEntitiesExtendedWorkforce = () => {
    const extendedWorkforceEntities = useExtendedWorkforceEntities();
    const reportPlaces = useReportPlaces();

    return useMemo(() => {
        if (reportPlaces.all.length === 0) {
            return false;
        }

        return extendedWorkforceEntities.length === reportPlaces.all.length;
    }, [extendedWorkforceEntities.length, reportPlaces.all.length]);
};
